<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Sales Reports</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item"><a href="/">Reports</a>
                            </li>
                            <li class="breadcrumb-item active">Sales Reports
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <form @submit.prevent="filterData">
                    <div class="d-flex justify-content-center mt-2 mb-2">
                        <div class="col-xl-4 col-md-4">
                            <label>Start date</label><br/>
                            <input type="date" v-model="reportFilter.start_date" class="form-control" required>
                        </div>

                        <div class="col-xl-4 col-md-4">
                            <label>End date</label><br/>
                            <input type="date" v-model="reportFilter.end_date" class="form-control" required>
                        </div>

                        <div class="col-xl-4 col-md-4">
                            <label>&nbsp;</label><br/>
                            <button type="submit" class="btn btn-primary">Filter</button>
                            <button type="button" class="btn btn-default" @click="resetFilter">Reset</button>
                        </div>
                    </div>
                </form>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6 mb-1">
                            <div class="stat-card">
                                <i class="fa fa-money-bill-wave stat-icon text-primary"></i>
                                <div class="stat-label">Total Revenue</div>
                                <div class="stat-value">{{ totalRevenue }}</div>
                            </div>
                        </div>

                        <div class="col-md-6 mb-1">
                            <div class="stat-card">
                                <i class="fa fa-receipt stat-icon text-success"></i>
                                <div class="stat-label">Platform Commission</div>
                                <div class="stat-value">{{ platformCommission }}</div>
                            </div>
                        </div>
                        <div class="col-md-6 mb-1">
                            <div class="stat-card">
                                <i class="fa fa-hand-holding-usd stat-icon text-secondary"></i>
                                <div class="stat-label">Driver Payouts</div>
                                <div class="stat-value">{{ driverPayouts }}</div>
                            </div>
                        </div>
                        <div class="col-md-6 mb-1">
                            <div class="stat-card">
                                <i class="fa fa-wallet stat-icon text-info"></i>
                                <div class="stat-label">Fleet Managers Payouts</div>
                                <div class="stat-value">{{ fleetPayouts }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <p class="text-center">
                    <b> {{ period }}</b>
                </p>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/inertia-vue';
import PieChart from "../../Shared/PieChart.vue";
import {Doughnut} from "vue-chartjs/legacy";

export default {
    metaInfo: {title: 'Sales Reports'},
    props: ['totalRevenue', 'platformCommission', 'driverPayouts', 'fleetPayouts', 'period'],
    layout: Layout,
    name: 'SalesReport',
    components: {
        Doughnut,
        PieChart,
        Link,
    },
    mixins: [],
    data: () => ({
        pieOptions: {
            responsive: true,
            maintainAspectRatio: false
        },
        reportFilter : {
            start_date: '',
            end_date: ''
        },
        period: '',
        pieData: {
            labels: [],
            datasets: []
        },
        excelData: {},
    }),
    mounted() {
    },

    methods: {
        generateReportName(name, fileType) {
            let now = new Date();
            let formatted = now.getFullYear() + '-' +
                String(now.getMonth() + 1).padStart(2, '0') + '-' +
                String(now.getDate()).padStart(2, '0') + '_' +
                String(now.getHours()).padStart(2, '0') + '-' +
                String(now.getMinutes()).padStart(2, '0') + '-' +
                String(now.getSeconds()).padStart(2, '0');

            return `${name}_${formatted}${fileType}`;
        },
        async filterData() {
            try {
                let results = await axios.get(route("admin.reports.sales"), {
                    params: {
                        start_date: this.reportFilter.start_date,
                        end_date: this.reportFilter.end_date,
                        api: true
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRevenue = results.data.totalRevenue;
                this.platformCommission = results.data.platformCommission;
                this.driverPayouts = results.data.driverPayouts;
                this.fleetPayouts = results.data.fleetPayouts;
                this.period = results.data.period;
            } catch (e) {
                console.log(e);
            }
        },

        pieThumbprint(labels, data, backgroundColor) {
            return {
                labels,
                datasets: [
                    {
                        backgroundColor,
                        data
                    }
                ]
            }
        },

        randomColor() {
            return '#' + Math.floor(Math.random() * 16777215).toString(16);
        },

        pieColor() {
            return ['#8E50EB', '#FFA87D'];
        },

        async resetFilter() {
            this.reportFilter = {
                start_date: '',
                end_date: ''
            }

            await this.filterData();
        },
    },
    computed: {
        formattedData() {
            const rows = [];

            // Create a row for column headers
            rows.push(['Device', 'Total']);

            // Add rows for each key-value pair in reportData
            for (const key in this.excelData) {
                rows.push([key, this.excelData[key]]);
            }

            return rows;
        }
    }
}
</script>
<style>
.chart-wrapper {
    width: 350px;      /* desired width */
    height: 350px;     /* desired height */
    display: flex;
    justify-content: center;
    align-items: center;
}
.chart-wrapper canvas {
    width: 100% !important;
    height: 100% !important;
}
</style>
